export default __webpack_public_path__ + "static/media/teamformation.d72d52c3.svg";